module.exports = __webpack_public_path__ + "img/Produktbild_groß.5bb1140a.jpg";